import { render, staticRenderFns } from "./PurchaseReceivesEdit.vue?vue&type=template&id=b8850728&scoped=true"
import script from "./PurchaseReceivesEdit.vue?vue&type=script&lang=js"
export * from "./PurchaseReceivesEdit.vue?vue&type=script&lang=js"
import style0 from "./PurchaseReceivesEdit.vue?vue&type=style&index=0&id=b8850728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8850728",
  null
  
)

export default component.exports